import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { FiArrowUpRight, FiCheck } from "react-icons/fi";

const proof = ["Founder-led", "Mobile product", "Backend system", "Live product"];

export default function Venture() {
  const reduce = useReducedMotion();

  const reveal = (delay = 0) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 16 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.3 },
          transition: { duration: 0.6, delay, ease: "easeOut" },
        };

  return (
    <section
      id="venture"
      className="relative overflow-hidden border-y-2 border-black/10 dark:border-white/10"
    >
      <div className="absolute inset-0 bg-stone-100/70 dark:bg-stone-950/60 pointer-events-none" aria-hidden />
      <div className="relative max-w-6xl mx-auto px-6 py-20 lg:py-24">
        <div className="lg:grid lg:grid-cols-12 lg:gap-12 lg:items-center">
          <div className="lg:col-span-7">
            <motion.div
              {...reveal()}
              className="flex items-center gap-3 font-mono text-[11px] font-bold uppercase tracking-[0.35em] text-stone-500 dark:text-stone-400"
            >
              <span className="relative flex h-2 w-2" aria-hidden>
                <span className="absolute inline-flex h-full w-full rounded-full bg-black/30 dark:bg-white/30 animate-ping" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-black dark:bg-white" />
              </span>
              Founding work | live
            </motion.div>

            <motion.h2
              {...reveal(0.08)}
              className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] text-black dark:text-white"
            >
              GurshaPlus
            </motion.h2>

            <motion.p
              {...reveal(0.14)}
              className="mt-3 font-mono text-xs uppercase tracking-[0.28em] text-stone-500 dark:text-stone-400"
            >
              Fuel your creative work.
            </motion.p>

            <motion.p
              {...reveal(0.2)}
              className="mt-6 text-lg text-stone-600 dark:text-stone-400 max-w-xl text-pretty leading-relaxed"
            >
              A creator monetization platform I founded and built end-to-end, giving creators a direct
              way to earn from the people who value their work. It is the strongest proof that I can
              turn an idea into a launched product.
            </motion.p>

            <motion.div {...reveal(0.26)} className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href="https://gurshaplus.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-black text-white dark:bg-white dark:text-black px-6 py-3.5 font-mono font-bold uppercase tracking-wider text-xs hover:bg-stone-800 dark:hover:bg-stone-200 transition-colors"
              >
                Visit gurshaplus.com <FiArrowUpRight className="shrink-0" aria-hidden />
              </a>
              <span className="text-sm font-medium text-stone-500 dark:text-stone-500">
                Founder | full-stack | solo build
              </span>
            </motion.div>
          </div>

          <motion.aside
            {...reveal(0.18)}
            className="hidden lg:block lg:col-span-5"
          >
            <div className="relative border-2 border-black dark:border-white bg-white text-black dark:bg-black dark:text-white p-8">
              <p className="font-display text-7xl font-semibold leading-none select-none" aria-hidden>
                G+
              </p>
              <div className="mt-8 grid gap-3">
                {proof.map((item) => (
                  <div key={item} className="flex items-center gap-3 border-t border-black/10 dark:border-white/15 pt-3 text-sm font-medium">
                    <FiCheck className="shrink-0" aria-hidden />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </motion.aside>
        </div>
      </div>
    </section>
  );
}
